import { getFirestore } from 'firebase/firestore'
import { initializeApp } from 'firebase/app'

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyBQdJCswtIq5kwWu9BnZs6rI6_g0ol42BY',
  authDomain: 'homescare-2023.firebaseapp.com',
  projectId: 'homescare-2023',
  storageBucket: 'homescare-2023.appspot.com',
  messagingSenderId: '969567339421',
  appId: '1:969567339421:web:0da5cb41c21e2d70c5a574',
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
export const db = getFirestore()
